<template>
  <div class="budget-content" :style="!client ? 'display: none;' : ''">
    <div v-if="clientId" @click="create()" class="add-button mx-6 mt-2">
      + NOVO ORÇAMENTO
    </div>
    <div class="budgets-content">
      <ListBudgets :budgets="budgets" @select="openBudgetDialog" @load-more="loadMore" />
    </div>

    <BudgetDialog
      v-if="budget_dialog.open"
      :dialog="budget_dialog"
      @close-dialog="closeBudgetDialog"
    />

  </div>
</template>

<script>
import BudgetService from '@/services/api/budget';
import BudgetDialog from '@/components/Budget/Dialog';
import ListBudgets from '@/components/Budget/ListBudgets';

export default {
  name: 'ListBudgetsWhatsApp',
  props: {
    client: {
      type: Object,
    },
  },
  components: {
    BudgetDialog,
    ListBudgets,
  },
  data () {
    return {
      clientId: null,
      budgets: [],
      budget_dialog: {
        open: false,
      },
      currentPage: 1,
      itemsPerPage: 15,
    }
  },
  watch: {
    client: {
      immediate: true,
      handler(client) {
        this.clientId = client ? client.id : null;

        if (client) {
          this.handleSearch();
        } else {
          this.budgets = [];
        }
      },
    },
  },
  methods: {
    openBudgetDialog(){
      this.budget_dialog = {
        open: true,
      };
    },
    closeBudgetDialog() {
      this.budget_dialog = { open: false };
      this.$store.dispatch('Budget/cleanSelectedBudget');
      this.handleSearch();
    },
    handleSearch() {
      this.currentPage = 1;
      this.budgets = [];
      this.$store.dispatch('Budget/setHasMoreData', false);

      if (this.clientId) {
        this.search();
      }
    },
    search() {
      this.$store.dispatch('Budget/setLoading', true);

      const queryParams = {
        client: this.clientId,
        status: '*',
        size: this.itemsPerPage,
        page: this.currentPage,
      };

      BudgetService.search(queryParams)
        .then((response) => {
          const responseData = response.data;

          if (responseData && responseData.rows) {
            const newBudgets = responseData.rows.filter(budget => !this.budgets.find(s => s.id === budget.id));
            this.budgets = [...this.budgets, ...newBudgets];
          }

          this.currentPage = responseData.currentPage || 1;
          const totalPages = responseData.totalPages || 1;
          const hasMoreData = this.currentPage < totalPages;

          this.$store.dispatch('Budget/setHasMoreData', hasMoreData);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.$store.dispatch('Budget/setLoading', false);
        });
    },
    loadMore() {
      this.currentPage += 1;
      this.search();
    },
    create() {
      BudgetService.create(
        {
          client_id: this.clientId,
          status: 'pendente',
        },
      ).then((response) => {
        this.$store.commit('Budget/SET_SELECTED_BUDGET', response.data.budget);

        this.$store.commit('Budget/ADD_LOG', {
          description: 'Orçamento criado',
          createdAt: new Date().toISOString(),
          user: this.$store.getters['Auth/user'],
        });

        this.openBudgetDialog();
      }).catch((error) => {
        console.error(error);
      });
    },
  },
}
</script>

<style lang="scss">
.budget-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: none !important;
  height: calc(100% - 90px) !important;

  .add-button {
    cursor: pointer;
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    padding: 10px 20px;
    margin-bottom: 15px;
    margin-top: 3px;
  }
}
</style>
